import { Injectable } from '@angular/core';
import { Error as FoundationError, isError } from 'fl-foundation';
import { AuthorizationData } from 'fl-platform-authorizer';
import { SessionStorageKeys } from '../../SessionStorageKeys';
import { PlaybackService } from '../playback/playback.service';

/**
 * Auth0 management
 */
@Injectable()
export class AuthService {
  constructor(private playbackService: PlaybackService) {}

  async getAuthData(): Promise<AuthorizationData> {
    try {
      this.playbackService.resetPlayback();

      const confData = sessionStorage.getItem(SessionStorageKeys.CONF_START);
      const splashStart = sessionStorage.getItem(SessionStorageKeys.ELAPSED_SPLASH)
        ? parseInt(sessionStorage.getItem(SessionStorageKeys.ELAPSED_SPLASH), 10)
        : 0;
      // sessionStorage.clear();
      sessionStorage.setItem(SessionStorageKeys.ELAPSED_SPLASH, '' + splashStart);
      sessionStorage.setItem(SessionStorageKeys.CONF_START, confData);

      const authData: AuthorizationData | FoundationError = await this.playbackService.initialiseSDK();
      if (isError(authData)) {
        return Promise.reject();
      } else {
        return Promise.resolve(authData);
      }
    } catch (error) {
      // clear local storage and reset SDK as anonymous user
      this.playbackService.resetPlayback();
      this.playbackService.intializeConfigurations();
      await this.playbackService.initialiseSDK();
      return Promise.reject(error);
    }
  }
}
